<template>
    <div id="userList">
        <div class="search">
            <div class="block_box">
                <div class="p_select search_day_list" >
                    <div class="search_label">车牌号</div>
                    <el-input placeholder="请输入车牌号" v-model="carNumber" clearable @change="getListData"></el-input>
                </div>

                <div class="p_select">
                    <el-button class="search_btn" @click="getListData">查询</el-button>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table id="dailyTestAndDeal" :data="dailyTestAndDealData" :height=winHeight ref="table_1" :cell-style="cellStyle" :header-cell-style="tableHeaderColor">
                <el-table-column prop="dossierId" label="档案ID" align="left"></el-table-column>
                <el-table-column prop="checkDay" label="日期" align="left"></el-table-column>
                <el-table-column prop="carNumber" label="车牌" align="left"></el-table-column>
                <el-table-column prop="saName" label="服务顾问" align="left"></el-table-column>
                <el-table-column prop="seriesName" label="车系" align="left"></el-table-column>
                <el-table-column prop="num" label="照片数量" align="left"></el-table-column>
                <el-table-column label="详情" width="180px">
                    <template slot-scope="scope">
                        <a  @click="showDetail(scope.row)"><span class="test_detail">查看</span></a>
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <el-drawer
                title="图片详情"
                left
                size="80%"
                :wrapperClosable="true"
                :visible.sync="showDetailBox"
                direction="rtl"
        >
            <div class="img_box">
                <div class="img_item" v-for="item in dataList" v-bind:key="item.index" >
                    <a >
                        <img :src="item.imgUrl" @click="bigImg(item.imgUrl)" />
                    </a>
                </div>
            </div>
        </el-drawer>

        <el-dialog
                :visible.sync="showBigImgBox"
                width="60%">
            <div class="big_img">
                <img :src="imgUrl" alt="">
            </div>
        </el-dialog>



    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  export default {
    name: "detectionSummary",
    data(){
      return {
        orgId:'',
        dailyTestAndDealData:[],
        winHeight:'200',

        carNumber:'',
        showDetailBox: false,
        dataList:[],
        showBigImgBox: false,
        imgUrl:'',
      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
      }
    },
    methods:{
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      getListData() {
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
        this.dailyTestAndDealData = []
        if (this.beginDate === "" || this.beginDate === null || this.endDate === "" || this.endDate === null ) {
          this.$message({
            message: "请选择查询日期",
            type: 'warning',
            duration:2000,
            offset:windiwHight/2
          });
          return;
        }
        const params = {
          carNumber: this.carNumber,
        }
        net.request("admin/manage/dossierMediaLibrary/queryMediaLibraryCountInfo", "post", params).then(res => {
          if (res.code == 0) {
            this.$message({
              message: '查询成功',
              type: 'success',
              duration:2000,
              offset:windiwHight/2
            });
            this.$nextTick(() => {
              this.$refs['table_1'].doLayout();
            })
            let data = res.data
            this.dailyTestAndDealData = data
            this.setWindowHeight();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
              duration:2000,
              offset:windiwHight/2
            });
          }
        })
      },
      showDetail(row){
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
        const params = {
          dossierId: row.dossierId
        }
        net.request("admin/manage/dossierMediaLibrary/getMediaLibraryImagesByDossierId", "post", params).then(res => {
          if (res.code == 0){
            let data = res.data
            if(data && data.length <= 0){
              this.$message({
                message: "暂无数据",
                type: 'success',
                duration:2000,
                offset:windiwHight/2
              });
            }else {
              this.showDetailBox = true
              let baseUrl = net.baseUrl+'admin/manage/dossierMediaLibrary/getMediaLibraryImage?imageId='
              let dataList = []
              data.forEach(item => {
                dataList.push({
                  imgUrl: baseUrl+item
                })
              })
              this.dataList = dataList
              console.log(dataList)
            }
          }else {
            this.$message({
              message: res.msg,
              type: 'warning',
              duration:2000,
              offset:windiwHight/2
            });
          }
        })
      },
      bigImg(imgUrl){
        this.showBigImgBox = true
        this.imgUrl = imgUrl
      },
      // 设置滚动高度
      setWindowHeight() {
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
        this.winHeight = windiwHight  - 186;
      },

    },
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 24px;
        .search {
            background: #fff;
            padding-top: 24px;
            margin-bottom: 24px;
            display: flex;
            .block_box{
                width: 100%;
                .p_select {
                    display: flex;
                    margin: 0 12px 0px 0;
                    font-size: 12px;
                    float: left;
                    .search_label{
                        font-family: 'PingFang SC';
                        font-style: normal;
                        margin-right: 12px;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 40px;
                        color: #787E86;
                        white-space:nowrap
                    }

                    .el-input , .el-select{
                        width: 160px;
                    }
                }
                .search_btn {
                    background: #2B54FC;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    color: #FFFFFF;
                    font-size: 14px;
                }
            }
        }

        .test_detail {
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            width: 60px;
            height: 24px;
            text-align: center;
            display: block;
            font-weight: 500;
            font-size: 11px;
            line-height: 24px;
            color: #364556;
        }

        .img_box {
            overflow: hidden;
            .img_item {
                width: 400px;
                height: 300px;
                margin-left: 12px;
                float: left;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .big_img {
            height: 80%;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
<style lang="less">
    .el-table .cell {

        white-space: pre-line;
    }
</style>
